var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcOptionProfileMobile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "5px",
    height: "23px",
    viewBox: "0 0 5 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icOptionProfileMobile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.45454545,5 C1.09893743,5 1.77635684e-15,3.88071187 1.77635684e-15,2.5 C1.77635684e-15,1.11928813 1.09893743,0 2.45454545,0 C3.81015348,0 4.90909091,1.11928813 4.90909091,2.5 C4.90909091,3.88071187 3.81015348,5 2.45454545,5 Z M11.5,5 C10.144392,5 9.04545455,3.88071187 9.04545455,2.5 C9.04545455,1.11928813 10.144392,0 11.5,0 C12.855608,0 13.9545455,1.11928813 13.9545455,2.5 C13.9545455,3.88071187 12.855608,5 11.5,5 Z M20.5454545,5 C19.1898465,5 18.0909091,3.88071187 18.0909091,2.5 C18.0909091,1.11928813 19.1898465,0 20.5454545,0 C21.9010626,0 23,1.11928813 23,2.5 C23,3.88071187 21.9010626,5 20.5454545,5 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-Members-Grid-OFF-Copy-7",
    transform: "translate(-344.000000, -437.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu-Icon",
    transform: "translate(347.000000, 449.000000) rotate(-270.000000) translate(-347.000000, -449.000000) translate(327.000000, 429.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icOptionProfileMobile",
    transform: "translate(8.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#333333",
    opacity: 0.600000024,
    xlinkHref: "#path-1"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOptionProfileMobile);
export default __webpack_public_path__ + "static/media/icOptionProfileMobile.bde0b4ae9b9615518c959ca8cade0379.svg";
export { ForwardRef as ReactComponent };